import React from 'react';
import {connect} from 'react-redux';
import {Map} from '@uiw/react-amap';
import {T} from 'Actions/translate';
import BasicButton from 'Components/common/BasicButton';
import BasicTextArea from 'Components/common/BasicTextArea';
import {
    getSysDict,
    punchSave,
    setHostCurrentPosition,
    setHostPunchMap,
    setPunchSuccessStatus,
} from 'Actions/host';
import {openNotification} from 'Actions/notification';
import Dialog from 'Components/common/Dialog';
import {CheckBox} from '@material-ui/icons';
import {Refresh} from '@material-ui/icons';

// Add Clock Commets Dialog Function
import BasicInput from '../common/BasicInput';
import {uploadAudio} from 'Utils/apiUtil';
import {Cancel} from '@material-ui/icons';
import util from 'Utils/commonUtil';

class GodMap extends React.Component {
    gaoMap = {};
    punchSubmitPending = false;
    punchActionLocked = false;
    isComponentActive = false;

    getDefaultPunchExceptionTypes = () => [
        {
            key: 'LOCATE_ERROR',
            value: T('shippment_inaccurate_positioning_system'),
        },
        {key: 'FORGOT', value: T('shippment_forget_punch')},
        {
            key: 'CUSTOMER_PICKUP',
            value: T('shippment_customer_pickup'),
        },
        {key: 'OTHERS', value: T('shippment_punch_exception_other')},
    ];

    normalizePunchExceptionTypes = (options) => {
        if (!Array.isArray(options)) {
            return [];
        }

        return options
            .map((option) => {
                if (!option || typeof option !== 'object') {
                    return null;
                }

                if (!option.key || !option.value) {
                    return null;
                }

                return {
                    key: option.key,
                    value: option.value,
                };
            })
            .filter(Boolean);
    };

    state = {
        tempPosition: {
            longitude: '',
            latitude: '',
        },
        aMap: {},
        map: {},
        marker: {},
        center: [108.899914, 34.232601],
        currentDiscount: 0,
        punchExceptionDialogOpened: false,
        punchStatus: '',
        exceptionPuncheTypeClass: '',
        remark: '',
        tabValue: 0,
        // audioUrl: [{
        //     "id": 1,
        //     "fileName": "example.mp3",
        //     "filePath": "/path/to/example.mp3"
        // }],
        audioUrl: [],
        deleteIndex: null,
        deleteFlg: false,
        comments: '',
        end: false,
        punchSubmitting: false,
        punchSuccessStatus: false,
        showTypeNotNullMessage: false,
        punchExceptionTypes: this.getDefaultPunchExceptionTypes(),
    };

    componentDidMount() {
        this.isComponentActive = true;
        this.props.getSysDict('PUNCH_EXCEPTION_TYPE').then((res) => {
            const punchExceptionTypes = this.normalizePunchExceptionTypes(
                res && res.data,
            );
            if (res && res.status === 'success' && punchExceptionTypes.length) {
                this.setState({
                    punchExceptionTypes,
                });
            }
        });
    }

    componentWillUnmount() {
        this.isComponentActive = false;
        this.punchSubmitPending = false;
    }

    setPunchSubmittingState = (punchSubmitting) => {
        if (this.isComponentActive) {
            this.setState({punchSubmitting});
        }
    };

    acquirePunchActionLock = () => {
        if (!this.isComponentActive || this.punchActionLocked) {
            return false;
        }

        this.punchActionLocked = true;
        this.setPunchSubmittingState(true);
        return true;
    };

    releasePunchActionLock = () => {
        this.punchSubmitPending = false;
        this.punchActionLocked = false;
        this.setPunchSubmittingState(false);
    };

    getClickPosition = (event) => {
        let tempClickPosition = [];
        tempClickPosition.push(event.lnglat.lat);
        tempClickPosition.push(event.lnglat.lng);
        let getDiscountValue = this.getDiscount(
            108.899939,
            34.232528,
            event.lnglat.lng,
            event.lnglat.lat,
        );
        this.setState({
            tempPosition: {
                longitude: event.lnglat.lng,
                latitude: event.lnglat.lat,
            },
            currentDiscount: getDiscountValue,
        });
    };

    getDiscount = (lng1, lat1, lng2, lat2) => {
        const radLat1 = (lat1 * Math.PI) / 180.0;
        const radLat2 = (lat2 * Math.PI) / 180.0;
        const a = radLat1 - radLat2;
        const b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
        let s =
            2 *
            Math.asin(
                Math.sqrt(
                    Math.pow(Math.sin(a / 2), 2) +
                        Math.cos(radLat1) *
                            Math.cos(radLat2) *
                            Math.pow(Math.sin(b / 2), 2),
                ),
            );
        s = s * 6378.137; // EARTH_RADIUS;
        s = Math.round(s * 10000) / 10000;
        s = s * 1000;
        if (isNaN(s)) {
            return 0;
        }
        // if (s > 100000) {
        //     // 大于100Km时
        //     s = Math.floor((s / 1000) * 100) / 100;
        //     return s.toFixed() + "km";
        // }
        // if (s > 1000 && s < 100000) {
        //     // 大于1000米时
        //     s = Math.floor((s / 1000) * 100) / 100;
        //     return s.toFixed(1) + "km";
        // }
        // 小于1000米直接返回
        return s.toFixed();
    };

    onCompleteHandle = (data) => {
        // data是具体的定位信息
        console.log(data, '======onComplete');
        let {hostPosition} = this.props;

        if (hostPosition.length > 0) {
            this.props.setHostCurrentPosition([]);
        }
        if (data && data.position !== 'undefined') {
            hostPosition[0] = data.position.lng;
            hostPosition[1] = data.position.lat;
            this.props.setHostCurrentPosition(hostPosition);
        }
    };

    punchExceptionHandle = () => {
        this.setState({
            punchExceptionDialogOpened: true,
        });
    };

    goBackAfterPunchSuccess = () => {
        if (
            this.isComponentActive &&
            util.isFunction(this.props.onPunchSuccess)
        ) {
            this.props.onPunchSuccess();
        }
    };

    isPunchSubmitting = () =>
        this.state.punchSubmitting || this.punchSubmitPending;

    punchHandle = () => {
        if (!this.acquirePunchActionLock()) {
            return;
        }

        const {shipmentItem} = this.props;

        let hostPosition = [];
        try {
            hostPosition = JSON.parse(localStorage.getItem('hostPosition'));
        } catch (err) {
            hostPosition = [];
        }
        // let punchDiscount = this.getDiscount(
        //     shipmentItem.longitude,
        //     shipmentItem.latitude,
        //     hostPosition[0],
        //     hostPosition[1],
        // );

        if (shipmentItem && shipmentItem.longitude && shipmentItem.latitude) {
            let p1 = [shipmentItem.longitude, shipmentItem.latitude];

            let punchDiscount = window.AMap.GeometryUtil.distance(
                p1,
                hostPosition,
            );

            console.log(
                'punchDiscount============================================:',
                punchDiscount,
            );

            let punchParams = {
                shipmentId: shipmentItem.shipments[0].id,
                punchStatus: 'SUCCESS',
                punchLongitude: hostPosition[0],
                punchLatitude: hostPosition[1],
                remark: '',
                punchDistance: punchDiscount,
            };

            if (punchDiscount > shipmentItem.punchDistance) {
                this.releasePunchActionLock();
                this.props.openNotification(
                    T('shippment_not_punch'),
                    'danger',
                    {bubbling: true},
                );
            } else {
                this.punchSubmitPending = true;
                this.props
                    .punchSave(punchParams)
                    .then((res) => {
                        if (res && res.status === 'success') {
                            this.props.setPunchSuccessStatus({$set: true});
                            this.props.openNotification(
                                T('shippment_punch_success'),
                                'success',
                                {bubbling: true},
                            );
                            this.goBackAfterPunchSuccess();
                        }
                    })
                    .catch(() => {
                        this.releasePunchActionLock();
                    })
                    .finally(() => {
                        if (this.isComponentActive) {
                            this.releasePunchActionLock();
                        }
                    });
            }
        } else {
            this.releasePunchActionLock();
            this.props.openNotification(
                T('shippment_punch_position_is_not_null'),
                'danger',
                {bubbling: true},
            );
        }
    };

    getAudioIDs = () => {
        const {audioUrl, comments} = this.state;
        let array = [];

        audioUrl.forEach((param, key) => {
            array.push(param.id);
        });

        return array;
    };

    exceptionPunchHandle = () => {
        if (!this.acquirePunchActionLock()) {
            return;
        }

        const {shipmentItem} = this.props;
        let {punchStatus, remark} = this.state;
        let hostPosition = [];
        try {
            hostPosition = JSON.parse(localStorage.getItem('hostPosition'));
        } catch (err) {
            hostPosition = [];
        }
        const hasHostPosition =
            Array.isArray(hostPosition) &&
            hostPosition.length >= 2 &&
            Number.isFinite(Number(hostPosition[0])) &&
            Number.isFinite(Number(hostPosition[1]));

        // let punchDiscount = this.getDiscount(
        //     shipmentItem.longitude,
        //     shipmentItem.latitude,
        //     hostPosition[0],
        //     hostPosition[1],
        // );

        if (
            shipmentItem.longitude &&
            shipmentItem.latitude &&
            hasHostPosition &&
            window.AMap &&
            window.AMap.GeometryUtil
        ) {
            let p1 = [shipmentItem.longitude, shipmentItem.latitude];

            let punchDiscount = window.AMap.GeometryUtil.distance(
                p1,
                hostPosition,
            );

            let exceptionPunchParams = {
                shipmentId: shipmentItem.shipments[0].id,
                punchStatus: punchStatus,
                punchLongitude: hostPosition[0],
                punchLatitude: hostPosition[1],
                remark: remark,
                punchDistance: punchDiscount,
            };
            if (punchStatus) {
                if (punchStatus === 'OTHERS' && !remark) {
                    this.releasePunchActionLock();
                    this.setState({
                        showTypeNotNullMessage: true,
                    });
                } else {
                    this.punchSubmitPending = true;
                    this.props
                        .punchSave(exceptionPunchParams)
                        .then((res) => {
                            if (res && res.status === 'success') {
                                this.setState({
                                    punchExceptionDialogOpened: false,
                                    remark: '',
                                    punchStatus: '',
                                });
                                this.props.setPunchSuccessStatus({$set: true});
                                this.props.openNotification(
                                    T('shippment_exception_punch_success'),
                                    'success',
                                    {
                                        testid: 'checkin-exception-success-message',
                                    },
                                );
                                this.goBackAfterPunchSuccess();
                            }
                        })
                        .catch(() => {
                            this.releasePunchActionLock();
                        })
                        .finally(() => {
                            if (this.isComponentActive) {
                                this.releasePunchActionLock();
                            }
                        });
                }
            } else {
                this.releasePunchActionLock();
                this.setState({
                    showTypeNotNullMessage: true,
                });
            }
        } else {
            if (punchStatus) {
                if (punchStatus === 'OTHERS' && !remark) {
                    this.releasePunchActionLock();
                    this.setState({
                        showTypeNotNullMessage: true,
                    });
                } else {
                    let noCustomerExceptionPunchParams = {
                        shipmentId: shipmentItem.shipments[0].id,
                        punchStatus: punchStatus,
                        punchLongitude: hasHostPosition ? hostPosition[0] : 0,
                        punchLatitude: hasHostPosition ? hostPosition[1] : 0,
                        remark: remark,
                        punchDistance: 0,
                    };
                    this.onCustomerDataExceptionPunch(
                        noCustomerExceptionPunchParams,
                    );
                }
            } else {
                this.releasePunchActionLock();
                this.setState({
                    showTypeNotNullMessage: true,
                });
            }
        }
    };

    onCustomerDataExceptionPunch = (noCustomerExceptionPunchParams) => {
        this.punchSubmitPending = true;
        this.props
            .punchSave(noCustomerExceptionPunchParams)
            .then((res) => {
                if (res && res.status === 'success') {
                    this.setState({
                        punchExceptionDialogOpened: false,
                        remark: '',
                        punchStatus: '',
                    });
                    this.props.setPunchSuccessStatus({$set: true});
                    this.props.openNotification(
                        T('shippment_exception_punch_success'),
                        'success',
                        {testid: 'checkin-exception-success-message'},
                    );
                    this.goBackAfterPunchSuccess();
                }
            })
            .catch(() => {
                this.releasePunchActionLock();
            })
            .finally(() => {
                if (this.isComponentActive) {
                    this.releasePunchActionLock();
                }
            });
    };

    handleTextArea = (name, value) => {
        if (value && value.length > 0) {
            let num = value && value.length;
            if (num >= 200) {
                num = 200;
            }
            this.setState({
                remark: value,
            });
        }
    };

    dialogDidClose = (key) => this.state[key] && this.setState({[key]: false});

    setPunchStatus = (punchStatus) => {
        let isDisabledRemark = false;
        if (punchStatus === 'LOCATE_ERROR' || punchStatus === 'FORGOT') {
            isDisabledRemark = true;
        } else {
            isDisabledRemark = false;
        }
        this.setState({
            punchStatus: punchStatus,
            showTypeNotNullMessage: false,
        });
    };

    initGaoMapHandle = (currentCenter) => {
        let _that = this;
        let isErrorMessageFlag = false;
        return (
            <Map
                zoom={12}
                ref={(instance) => {
                    if (instance && instance.map) {
                        const bounds = instance.map.getBounds();
                        // console.log('instance', instance, bounds);
                    }
                }}
                // onClick={(event) => {
                //     this.getClickPosition(event);
                // }}
                resizeEnable={true}
                dragEnable={true}
                zoomEnable={true}>
                {({AMap, map, container}) => {
                    // console.log('map', map, 'AMap', AMap);
                    if (map) {
                        const marker = new AMap.Marker();
                        // marker.setMap(map);
                        marker.setPosition(currentCenter);
                        map.add(marker);
                        marker.setTitle('送货点在此处');
                        marker.setLabel({
                            offset: new AMap.Pixel(20, 20), //设置文本标注偏移量
                            content: "<div class='info'>送货点在此处</div>", //设置文本标注内容
                            direction: 'right', //设置文本标注方位
                        });

                        // map.setCenter(currentCenter);

                        let geolocation = {};

                        let PI = 3.14159265358979324;
                        let firstMarkerFlag = false;
                        let tempMarker = {};
                        let mapOptions = {
                            showButton: true, //是否显示定位按钮
                            buttonPosition: 'LB', //定位按钮的位置
                            buttonOffset: new AMap.Pixel(10, 20), //定位按钮距离对应角落的距离
                            showMarker: true, //是否显示定位点
                            // panToLocation: true,
                            // markerOptions: {
                            //     //自定义定位点样式，同Marker的Options
                            //     offset: new AMap.Pixel(-18, -36),
                            //     content:
                            //         '<img src="https://a.amap.com/jsapi_demos/static/resource/img/user.png" style="width:26px;height:26px"/>',
                            // },
                            enableHighAccuracy: true,
                            zoomToAccuracy: true,
                            convert: true,
                            showCircle: false,
                        };

                        map.plugin('AMap.Geolocation', function () {
                            geolocation = new AMap.Geolocation(mapOptions);
                            // map.addControl(geolocation);
                            // setTimeout(() => {
                            //     geolocation.getCurrentPosition();
                            // }, 50);
                            geolocation.getCurrentPosition();
                            geolocation.isSupported();
                            geolocation.watchPosition();
                            geolocation.clearWatch();
                            AMap.event.addListener(
                                geolocation,
                                'complete',
                                onComplete,
                            );

                            function onComplete(data) {
                                // data是具体的定位信息
                                //    alert(
                                //         JSON.stringify(data)
                                //     );
                                let newData = [];
                                if (!firstMarkerFlag) {
                                    firstMarkerFlag = true;
                                    newData = getCoordinate(
                                        data.position.lng,
                                        data.position.lat,
                                    );
                                    tempMarker = new AMap.Marker({
                                        position: newData,
                                        offset: new AMap.Pixel(-18, -36),
                                        title: '我的位置',
                                        content:
                                            '<img src="https://a.amap.com/jsapi_demos/static/resource/img/user.png" style="width:26px;height:26px"/>',
                                    });
                                    map.remove(tempMarker);
                                    map.add(tempMarker);
                                    map.setCenter(newData);

                                    let hostPosition = [];
                                    if (
                                        localStorage.getItem('hostPosition') &&
                                        JSON.parse(
                                            localStorage.getItem(
                                                'hostPosition',
                                            ),
                                        ).length > 0
                                    ) {
                                        localStorage.setItem(
                                            'hostPosition',
                                            JSON.stringify([]),
                                        );
                                        hostPosition = [];
                                    }
                                    if (data && data.position !== 'undefined') {
                                        hostPosition[0] = newData[0];
                                        hostPosition[1] = newData[1];
                                        localStorage.setItem(
                                            'hostPosition',
                                            JSON.stringify(hostPosition),
                                        );
                                    }
                                }
                            }

                            _that.gaoMap = map;

                            AMap.event.addListener(
                                geolocation,
                                'error',
                                (data) => {
                                    console.log(data);
                                    if (!isErrorMessageFlag) {
                                        isErrorMessageFlag = true;
                                        _that.getGeolocationResult(
                                            data.message,
                                        );
                                    }
                                },
                            );

                            //纬度转换
                            function transformLatitude(x, y) {
                                let num =
                                    -100.0 +
                                    2.0 * x +
                                    3.0 * y +
                                    0.2 * y * y +
                                    0.1 * x * y +
                                    0.2 * Math.sqrt(Math.abs(x));
                                num +=
                                    ((20.0 * Math.sin(6.0 * x * PI) +
                                        20.0 * Math.sin(2.0 * x * PI)) *
                                        2.0) /
                                    3.0;
                                num +=
                                    ((20.0 * Math.sin(y * PI) +
                                        40.0 * Math.sin((y / 3.0) * PI)) *
                                        2.0) /
                                    3.0;
                                num +=
                                    ((160.0 * Math.sin((y / 12.0) * PI) +
                                        320 * Math.sin((y * PI) / 30.0)) *
                                        2.0) /
                                    3.0;
                                return num;
                            }
                            //经度转换
                            function transformLongitude(x, y) {
                                let num =
                                    300.0 +
                                    x +
                                    2.0 * y +
                                    0.1 * x * x +
                                    0.1 * x * y +
                                    0.1 * Math.sqrt(Math.abs(x));
                                num +=
                                    ((20.0 * Math.sin(6.0 * x * PI) +
                                        20.0 * Math.sin(2.0 * x * PI)) *
                                        2.0) /
                                    3.0;
                                num +=
                                    ((20.0 * Math.sin(x * PI) +
                                        40.0 * Math.sin((x / 3.0) * PI)) *
                                        2.0) /
                                    3.0;
                                num +=
                                    ((150.0 * Math.sin((x / 12.0) * PI) +
                                        300.0 * Math.sin((x / 30.0) * PI)) *
                                        2.0) /
                                    3.0;
                                return num;
                            }
                            // 坐标转换
                            function calculation(longitude, latitude) {
                                let a = 6378245.0; // 卫星椭球坐标投影到平面地图坐标系的投影因子。
                                let ee = 0.00669342162296594323; // 椭球的偏心率。
                                let lat = transformLatitude(
                                    longitude - 105.0,
                                    latitude - 35.0,
                                );
                                let lng = transformLongitude(
                                    longitude - 105.0,
                                    latitude - 35.0,
                                );
                                let radLat = (latitude / 180.0) * PI;
                                let magic = Math.sin(radLat);
                                magic = 1 - ee * magic * magic;
                                let sqrtMagic = Math.sqrt(magic);
                                lat =
                                    (lat * 180.0) /
                                    (((a * (1 - ee)) / (magic * sqrtMagic)) *
                                        PI);
                                lng =
                                    (lng * 180.0) /
                                    ((a / sqrtMagic) * Math.cos(radLat) * PI);
                                return {
                                    longitude: lng,
                                    latitude: lat,
                                };
                            }
                            // 判断是否为国外坐标
                            function isOutOfChina(longitude, latitude) {
                                if (
                                    longitude < 72.004 ||
                                    longitude > 137.8347
                                ) {
                                    return true;
                                }
                                if (latitude < 0.8293 || latitude > 55.8271) {
                                    return true;
                                }
                                return false;
                            }
                            // GPS坐标 转 高德坐标
                            function getCoordinate(longitude, latitude) {
                                longitude = Number(longitude);
                                latitude = Number(latitude);
                                if (isOutOfChina(longitude, latitude)) {
                                    //国外
                                    return {
                                        longitude: longitude,
                                        latitude: latitude,
                                    };
                                } else {
                                    //国内
                                    let obj = calculation(longitude, latitude);
                                    return [
                                        (longitude + obj.longitude).toFixed(6),
                                        (latitude + obj.latitude).toFixed(6),
                                    ];
                                }
                            }
                        });
                    }
                    return;
                }}
            </Map>
        );
    };

    getGeolocationResult = (message) => {
        if (message === 'Geolocation permission denied.') {
            this.props.openNotification(
                T('shippment_permission_disabled'),
                'danger',
            );
        }
    };
    refreshGodMap = () => {
        console.log(this.gaoMap);
        // this.gaoMap.getCurrentPosition();
        let shipmentItem = this.props.shipmentItem;
        let currentCenter = [];
        if (shipmentItem.longitude && shipmentItem.latitude) {
            currentCenter.push(shipmentItem.longitude);
            currentCenter.push(shipmentItem.latitude);
        }
        this.initGaoMapHandle();
    };

    // Add Clock Commets Dialog Function
    dialogDidClose = (key) => {
        this.state[key] && this.setState({[key]: false});
    };

    handleChange = (event, value) => {
        this.setState({tabValue: value});
    };

    handleCommentsChange = (name, value) => {
        this.setState({comments: value});
    };

    render() {
        let {
            currentDiscount,
            center,
            punchExceptionDialogOpened,
            punchStatus,
            remark,
            tabValue,
            audioUrl,
            deleteIndex,
            deleteFlg,
            comments,
            end,
            punchSubmitting,
            showTypeNotNullMessage,
            punchExceptionTypes,
        } = this.state;

        let shipmentItem = this.props.shipmentItem;
        // console.log(shipmentItem);

        let currentCenter = [];
        if (shipmentItem && shipmentItem.longitude && shipmentItem.latitude) {
            currentCenter.push(shipmentItem.longitude);
            currentCenter.push(shipmentItem.latitude);
        }

        if (currentCenter.length <= 0) {
            currentCenter = center;
        }

        return (
            <>
                <div className="god-map-container">
                    {/* <div
                        className="refresh-map-area"
                        onClick={() => {
                            this.refreshGodMap();
                        }}>
                        <Refresh className="icon" />
                        <div>{T('shippment_refresh_map')}</div>
                    </div> */}

                    {shipmentItem.showOrderRelatedTask && (
                        <div className="notice-lock container-max-width is-fixed">
                            <div className="notice-lock-text">
                                {T('shipment_punch_host_checkin')}
                            </div>
                        </div>
                    )}

                    {this.initGaoMapHandle(currentCenter)}
                    {currentDiscount > 0 ? (
                        <div className="clicked-signed-content">
                            {T(
                                currentDiscount <= 500
                                    ? 'clocked_signed_success'
                                    : 'clocked_signed_failed',
                                [currentDiscount],
                            )}
                        </div>
                    ) : null}

                    <div className="footer-warp">
                        <div className="shipment-punch-footer container-max-width is-fixed">
                            <BasicButton
                                className="punch-exception-btn"
                                testid="shipment-punch-exception-btn"
                                type="primary"
                                onClickOfSingleTap={() =>
                                    this.punchExceptionHandle()
                                }>
                                <span>{T('shipment_punch_exception')}</span>
                            </BasicButton>
                            <BasicButton
                                className="current-punch-btn"
                                testid="shipment-current-punch-btn"
                                type="primary"
                                loading={punchSubmitting}
                                disabled={punchSubmitting}
                                onClickOfSingleTap={() => this.punchHandle()}>
                                <span>{T('user_center_signed')}</span>
                            </BasicButton>
                        </div>
                    </div>

                    <Dialog
                        opened={punchExceptionDialogOpened}
                        dialogDidClose={() =>
                            this.dialogDidClose('punchExceptionDialogOpened')
                        }
                        options={{bgClickClose: true}}>
                        <div className="punch-exception-dialog">
                            <h5 className="punch-exception-dialog-title text-center">
                                {T('shipment_punch_exception')}
                            </h5>
                            <div className="punch-exception-container">
                                <div className="exception-type">
                                    {punchExceptionTypes.map((option) => (
                                        <div
                                            key={option.key}
                                            testid={`checkin-exception-reason-location-${option.key}`}
                                            className={
                                                punchStatus === option.key
                                                    ? 'punch-select-type selected-type'
                                                    : 'punch-select-type'
                                            }
                                            onClick={() => {
                                                this.setPunchStatus(option.key);
                                            }}>
                                            {option.value}
                                        </div>
                                    ))}
                                </div>
                                <div className="exception-punch-textarea-are">
                                    {punchStatus === 'OTHERS' ? (
                                        <div className="required-textarea">
                                            *
                                        </div>
                                    ) : null}
                                    <BasicTextArea
                                        type="text"
                                        inputValid={this.handleTextArea}
                                        defalutValue={remark}
                                        testid="shipment-exception-remark"
                                        clearInput={this.clearInput}
                                        maxlength={200}
                                        value={remark}
                                        rows={3}
                                        placeholder={T(
                                            'fone_order_enter_comments',
                                        )}
                                    />
                                </div>
                                {showTypeNotNullMessage ? (
                                    <div className="punch-type-not-null">
                                        {punchStatus === 'OTHERS'
                                            ? T(
                                                  'shippment_punch_exception_other_type',
                                              )
                                            : T(
                                                  'shippment_exception_punch_status_is_not_null',
                                              )}
                                    </div>
                                ) : null}
                            </div>
                            <div className="exception-punch-btn-container">
                                <BasicButton
                                    type="primary"
                                    className="exception-punch-btn"
                                    loading={punchSubmitting}
                                    disabled={punchSubmitting}
                                    onClickOfSingleTap={
                                        this.exceptionPunchHandle
                                    }>
                                    {T('shipment_exception_punch')}
                                </BasicButton>
                            </div>
                        </div>
                    </Dialog>
                </div>
                <pre style={{padding: 10, marginTop: 10}}>
                    {/* {data ? JSON.stringify(data, null, 2) : '{正在获取}'} */}
                </pre>
            </>
        );
    }
}

// export default GodMap;

const mapStateToProps = (state) => {
    const {host, localData, auth} = state;
    return {
        localData,
        hostPosition: host.hostPosition,
        adminUser: auth.adminUser,
    };
};

const mapDispatchToProps = {
    getSysDict,
    punchSave,
    setHostCurrentPosition,
    openNotification,
    setHostPunchMap,
    setPunchSuccessStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(GodMap);
